module.exports = __webpack_public_path__ + "static/img/app_android_phone_mobile.6897088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appRecommend/app_android_phone_mobile.png
// module id = IsQu
// module chunks = 1